import webRouterZiggy from './webRouterZiggy.js';
import {WebsiteRouter} from "./webRouters";
import {App,Plugin} from "vue";

export function route(name :string, params:any={}, absolute:any={}, config:any=WebsiteRouter):any {
    if (!params) {
        params = {};
    }
    if (!params.lang && (import.meta.env.VITE_APP_LOCALE!==document.documentElement.lang)) {
        params.lang = document.documentElement.lang || import.meta.env.VITE_APP_LOCALE; // Default to 'en' if no lang is set
    }
    const router:any = new webRouterZiggy(name , params, absolute, config);

    return name ? router.toString() : router;
}
export function getUrlLastSegment(url:string):any {
    return url.split('/').filter(Boolean).pop();
}
export function getSegmentAfter(url: string, key: string): string | undefined {
    const segments = url.split('/').filter(Boolean);
    const idx = segments.indexOf(key);
    if (idx !== -1 && idx + 1 < segments.length) {
        return segments[idx + 1];
    }
    return undefined;
}
const adminRouter:Plugin = {
    install(app:App, options:any) {
        const r:any = (name:any, params:any, absolute:any,config=options):any =>
            route(name, params, absolute,config );

        if (parseInt(app.version) > 2) {
            app.config.globalProperties.route = r;
            app.provide('route', r);
        } else {
            app.mixin({
                methods: {
                    route: r,
                },
            });
        }
    },
};
export default adminRouter
